<template>
  <div class="layout-flex" :class="{'in-modal': inModal, 'hide-image': hideBanner}">
    <div class="flex-item-image">
       <LoginBanner :inModal="inModal"/>
    </div>
    <div class="flex-item-content">
      <!-- <img
        class="logo"
        width="160"
        height="60"
        alt="rxc logo"
        :src="require('@/assets/tpbf/TPBF-logo-body.png')"
      /> -->
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import LoginBanner from '../../presentation/pages/page-login/components/LoginBanner.vue';
export default {
  name: "LayoutLanding",
  components: {
    LoginBanner
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideBanner: {
      type: Boolean,
      default: false,
    },
    inModal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  computed: {
    loginBanner() {
      return this.$store.getters.getLoginBanner;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.layout-flex {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .flex-item-image {
    flex: 2;
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .flex-item-content {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    img {
      width: 100%;
      max-width: 200px;
      object-fit: contain;
    }
  }
  &:is(.in-modal) {
    flex-direction: column;
    .flex-item-image {
      max-height: 50%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .flex-item-content {
      width: 100%;
      position: relative;
      max-width: 100% !important;

      .logo {
        z-index: 2;
        position: absolute;
        top: -40px;
      }
    }
  }
  &.hide-image {
    min-height: 600px;
    .flex-item-image {
      display: none;
    }
  }
}
@media (max-width: 800px) {
  .layout-flex {
    flex-direction: column;
    .flex-item-image {
      max-height: 50%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .flex-item-content {
      width: 100%;
      position: relative;
      max-width: 100% !important;

      .logo {
        z-index: 2;
        position: absolute;
        top: -40px;
      }
    }
  }
}
</style>
